export interface IMostObservedProps {
  moduleName: MostObservedModuleName;
  barColor: string;
}

export enum MostObservedModuleName {
  objects = "objects",
  species = "species",
}
